import scheduledCstDetailsLocale from './en.json'

const en = {
  scheduledCstDetails: scheduledCstDetailsLocale,
}

export default en
